// Dashboard.jsx
import React, { useEffect, useState } from 'react';
import styles from '../styles/Dashboard.module.scss';
import Stats from '../components/Stats/Stats';
import { Helmet } from 'react-helmet-async';
import StatsChart from '../components/StatsCharts/StatsChart';
import IncomeExpenseMonthsChart from '../components/StatsCharts/IncomeExpenseMonthsChart';
import TopCategoriesChart from '../components/StatsCharts/TopCategoriesChart';

const Dashboard = () => {
  const [monthKey, setMonthKey] = useState(() => {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    return `${y}-${m}`;
  });

  const [rangeLabel, setRangeLabel] = useState('');
  const [compareText, setCompareText] = useState('');

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const res = await fetch(
          `/api/stats/compareMonth?month=${encodeURIComponent(monthKey)}`
        );
        const data = await res.json();
        if (!res.ok) throw new Error(data?.error || 'Ошибка сравнения');
        if (!cancelled) setCompareText(String(data?.text || ''));
      } catch {
        if (!cancelled) setCompareText('');
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [monthKey]);

  return (
    <>
      <Helmet>
        <title>ФА | Главная</title>
      </Helmet>

      <div className={styles.Dashboard}>
        <Stats onMonthChange={setMonthKey} />

        <div className={styles.chart__header}>
          <h4 className={styles.chart__title}>Аналитика за выбранный месяц</h4>
          {compareText ? (
            <h4 className={styles.chart__compare}>{compareText}</h4>
          ) : null}
        </div>

        <div className={styles.stats__chart}>
          <h4 className={styles.chart__month}>{rangeLabel}</h4>
          <h4 className={styles.chart__subtitle}>
            Сравнение доходов и расходов
          </h4>

          <div className={styles.chart__legends}>
            <div className={styles.chart__legend}>
              <div className={styles.legend__color}></div>
              <h4 className={styles.legend__title}>Доход</h4>
            </div>
            <div className={styles.chart__legend}>
              <div className={styles.legend__color}></div>
              <h4 className={styles.legend__title}>Расход</h4>
            </div>
          </div>

          <StatsChart month={monthKey} onRangeChange={setRangeLabel} />
        </div>

        <div className={styles.charts}>
          <div className={styles.multi__chart}>
            <div className={styles.chart__tabs}>
              <button className={styles.chart__tab}>Категории</button>
              <button className={styles.chart__tab}>CS</button>
              <button className={styles.chart__tab}>CS</button>
              <button className={styles.chart__tab}>CS</button>
            </div>

            <div className={styles.chart__content}>
              <TopCategoriesChart monthKey={monthKey} />
            </div>
          </div>

          <div className={styles.chart}>
            <div className={styles.chart__gradient}></div>
            <h1 className={styles.chart__name}>
              Аналитика за последние 6 месяцев
            </h1>
            <IncomeExpenseMonthsChart />
            <div className={styles.chart__gradient}></div>
          </div>
        </div>

        <div className={styles.stats__gr}></div>
      </div>
    </>
  );
};

export default Dashboard;
